export class CookieConstants {
    public static tokenInCookieKey = "Uddannelseslaege.BearerToken";
    public static isValidBrowserSessionKey = "ValidSessionCreatedAt";
}
